// 墙
import rlModelData from "./rlModelData";
import store from "@/store/index";
import {
  getEntityData,
  saveDatabaseStore,
} from "@/rlMxModules/operate/operateApi";
import { getPKPM_WallHoleData } from "@/rlMxModules/Opencascad/getModelDrawData";
import { McDbPolyline, McGePoint3d, McCmColor, McGeVector3d } from "mxcad";
import { MovePt } from "../operate/structural";

class rlWallHoleData extends rlModelData {
  getModel3dData = store.state.globalData.rl_wasm_module.getModel3dData;
  // wasm接口方法
  // getPKPM_WallHoleData =
  //   store.state.globalData.rl_wasm_module.getPKPM_WallHoleData;
  constructor() {
    super();
    this.componentType = "wallHole";
    this.points = []; // 顶点数据
    this.deviation = 0;

    this.m_gridData = {}; //关联的网格数据
    // this.m_sectParamData = {}; //墙截面数据
    // this.SectData = []; //墙截面组合数据

    this.m_wallThick = 0; //墙洞所在墙的墙厚
    this.m_wallEcc = 0; //墙洞所在墙的偏轴

    this.Ecc = null; //洞口定位距离
    this.HDiff = null; //洞口底部标高

    this.classTypeName = "rlWallHole"; // 墙

    this._threeObj = null; ////三维图形对象

    this.Color = null;
    this.ModelType = "墙洞";
    this.m_groupName = "rlWallHoleGroup"; //组名

    this.isWasmGeted = false; //是否已经获取wasm数据
    this.Mat = null; //材料
    this.MatName = ""; //材料名称
    this.doorsWindowsType = null; //门窗竖向,1==门,0==窗,2==洞
    this.startPoint = null;
    this.endPoint = null;
    this.otherDrawIds = []; //门窗的内填充(并非真的填充,是额外绘制多段线)
    this.draw2dData = {}; //绘制2维数据
    this.IsPartitionWall = 0; //布置在墙还是隔墙上 0、墙 1、隔墙
    this.doorOpenType = null; //门类型
  }

  initData(obj) {
    super.initData(obj);
    let tempOtherData = !this.OtherData
      ? {}
      : typeof this.OtherData === "string"
      ? JSON.parse(this.OtherData)
      : this.OtherData;

    if (obj.m_gridData && obj.m_gridData.classTypeName == "rlGrid") {
      //兼容老数据
      this.startPoint = new McGePoint3d(...obj.m_gridData.m_stJoint.m_pt);
      this.endPoint = new McGePoint3d(...obj.m_gridData.m_edJoint.m_pt);
    } else if (
      obj.m_gridData &&
      obj.m_gridData.classTypeName == "rlPartitionWallSeg" &&
      obj.m_gridData.m_gridData
    ) {
      this.startPoint = new McGePoint3d(
        obj.m_gridData.m_gridData.m_stJoint.m_pt[0],
        obj.m_gridData.m_gridData.m_stJoint.m_pt[1],
        0
      );
      this.endPoint = new McGePoint3d(
        obj.m_gridData.m_gridData.m_edJoint.m_pt[0],
        obj.m_gridData.m_gridData.m_edJoint.m_pt[1],
        0
      );
    } else if (
      tempOtherData &&
      tempOtherData.startPoint &&
      tempOtherData.endPoint
    ) {
      this.startPoint = new McGePoint3d(
        tempOtherData.startPoint.x,
        tempOtherData.startPoint.y,
        0
      );
      this.endPoint = new McGePoint3d(
        tempOtherData.endPoint.x,
        tempOtherData.endPoint.y,
        0
      );
    }

    this.IsPartitionWall = obj.IsPartitionWall;
    this.m_gridData = obj.m_gridData;
    this.m_wallThick = obj.m_wallThick; //墙洞所在墙的墙厚
    this.m_wallEcc = obj.m_wallEcc; //墙洞所在墙的偏轴
    // const wallSect = obj.wallSect;
    this.Ecc = obj.Ecc; //洞口定位距离
    this.HDiff = obj.HDiff; //洞口底部标高
    this.Color = obj.Color;
    //与网格数据绑定
    this.m_gridData.m_wallHoleId = this.Guid;
    this.index2dData = obj.index2dData;
    this.index3dData = obj.index3dData;
    this.points = obj.points;
    this.doorsWindowsType = obj.doorsWindowsType;
    this.Mat = obj.Mat;
    //与网格数据绑定
    if (
      this.m_gridData.classTypeName == "rlPartitionWallSeg" &&
      !this.m_gridData.m_HoleIdArray.includes(this.Guid)
    ) {
      this.m_gridData.m_HoleIdArray.push(this.Guid);
    }
    this.index2dData = obj.index2dData;
    this.index3dData = obj.index3dData;
    this.points = obj.points;

    this.Color = obj.Color ? obj.Color : "#fff";
    this.OtherData = obj.OtherData;
    if (typeof this.OtherData === "string") {
      this.OtherData = JSON.parse(this.OtherData || "{}");
    } else if (!this.OtherData) {
      this.OtherData = {};
    }

    if (this.OtherData && !this.OtherData.doorLeftRight) {
      this.OtherData.doorLeftRight = 1;
    }
    if (this.OtherData && !this.OtherData.doorUpDown) {
      this.OtherData.doorUpDown = 1;
    }
    if (obj.doorOpenType) {
      this.doorOpenType = obj.doorOpenType;
      this.OtherData.doorOpenType = obj.doorOpenType;
    } else if (this.OtherData && this.OtherData.doorOpenType) {
      this.doorOpenType = this.OtherData.doorOpenType;
    } else if (this.OtherData && !this.OtherData.doorOpenType) {
      this.doorOpenType = 1;
      this.OtherData.doorOpenType = 1;
    }
    // this.OtherData = JSON.stringify(this.OtherData);
    this.setMatName();
  }

  setMatName() {
    switch (this.Mat) {
      case 52:
        this.MatName = "玻璃";
        break;
      case 53:
        this.MatName = "金属";
        break;
      case 54:
        this.MatName = "轻质材料";
        break;
      case 55:
        this.MatName = "人造板材";
        break;
      case 56:
        this.MatName = "其他材料";
        break;
      default:
        this.MatName = "";
        break;
    }
  }

  updateThisObj(obj, redraw = true, vecMove = null) {
    if (vecMove) {
      let otherData = null;
      if (this.OtherData) {
        if (typeof this.OtherData === "string") {
          otherData = JSON.parse(this.OtherData);
          if (typeof otherData === "string") {
            otherData = JSON.parse(otherData);
          }
        } else {
          otherData = this.OtherData;
        }

        let startPoint = new THREE.Vector3(
          otherData.startPoint.x,
          otherData.startPoint.y,
          0
        );
        let endPoint = new THREE.Vector3(
          otherData.endPoint.x,
          otherData.endPoint.y,
          0
        );
        startPoint.add(vecMove);
        endPoint.add(vecMove);
        otherData = {
          startPoint: {
            x: startPoint.x,
            y: startPoint.y,
            z: 0,
          },
          endPoint: {
            x: endPoint.x,
            y: endPoint.y,
            z: 0,
          },
        };
      }
      obj.OtherData = otherData ? JSON.stringify(otherData) : "";
      obj.startPoint = new McGePoint3d(
        otherData.startPoint.x,
        otherData.startPoint.y,
        0
      );
      obj.endPoint = new McGePoint3d(
        otherData.endPoint.x,
        otherData.endPoint.y,
        0
      );
    }

    super.updateThisObj(obj, redraw);

    if (
      this.m_gridData.classTypeName == "rlGrid" &&
      this.m_gridData.m_wallId &&
      redraw
    ) {
      let rlWall = getEntityData({
        Guid: this.m_gridData.m_wallId,
        classTypeName: "rlWallSeg",
      });
      if (rlWall) {
        rlWall.drawBreakWall();
      }
    } else if (this.m_gridData.classTypeName == "rlPartitionWallSeg") {
      this.m_gridData.drawBreakWall();
    }
    this.setMatName();
  }

  //绘制窗样式
  drawWindowStyle() {
    if (!this.draw2dData) return;
    let visible = store.state.displayData.windowsDisplay;
    let interval = this.m_wallThick / 3;
    let startPt = this.draw2dData.ptLongStart;
    let endPt = this.draw2dData.ptLongEnd;
    startPt = MovePt(startPt, this.draw2dData.vecShort, interval);
    endPt = MovePt(endPt, this.draw2dData.vecShort, interval);

    let line1 = new McDbPolyline();
    line1.addVertexAt(startPt);
    line1.addVertexAt(endPt);
    line1.setxDataString("Guid", this.Guid);
    line1.setxDataString("classTypeName", this.classTypeName);
    line1.trueColor = new McCmColor(this.Color.r, this.Color.g, this.Color.b);
    line1.visible = visible;
    let polylineMcDb1 = rlAppObj.mxcadObject.drawEntity(line1);
    this.otherDrawIds.push(polylineMcDb1);

    startPt = MovePt(startPt, this.draw2dData.vecShort, interval);
    endPt = MovePt(endPt, this.draw2dData.vecShort, interval);
    let line2 = new McDbPolyline();
    line2.addVertexAt(startPt);
    line2.addVertexAt(endPt);
    line2.setxDataString("Guid", this.Guid);
    line2.setxDataString("classTypeName", this.classTypeName);
    line2.trueColor = new McCmColor(this.Color.r, this.Color.g, this.Color.b);
    line2.visible = visible;
    let polylineMcDb2 = rlAppObj.mxcadObject.drawEntity(line2);
    this.otherDrawIds.push(polylineMcDb2);
  }

  //绘制门样式
  drawDoorStyle() {
    if (this.doorOpenType == 1) {
      this.drawSingleDoorStyle();
    } else if (this.doorOpenType == 2) {
      this.drawDoubleDoorStyle();
    } else if (this.doorOpenType == 3) {
      this.drawFlatDoorStyle();
    }
  }

  //绘制单开门样式
  drawSingleDoorStyle() {
    if (!this.draw2dData) return;
    let visible = store.state.displayData.doorsDisplay;
    if (!this.OtherData) return;
    let OtherData = null;
    if (typeof this.OtherData === "string") {
      OtherData = JSON.parse(this.OtherData);
      if (typeof OtherData === "string") {
        OtherData = JSON.parse(OtherData);
      }
    } else {
      OtherData = this.OtherData;
    }

    let doorLeftRight = OtherData.doorLeftRight;
    let doorUpDown = OtherData.doorUpDown;

    // 获取门的基本点位和向量
    let ptLongStart = this.draw2dData.ptLongStart;
    let ptLongEnd = this.draw2dData.ptLongEnd;
    let vecShort = this.draw2dData.vecShort;
    if (doorUpDown == 2) {
      let shortStart = this.draw2dData.ptShortStart;
      let shortEnd = this.draw2dData.ptShortEnd;
      let dist = shortStart.distanceTo(shortEnd);
      ptLongStart = MovePt(ptLongStart, vecShort, dist);
      ptLongEnd = MovePt(ptLongEnd, vecShort, dist);
    }
    if (
      (doorLeftRight == 2 && doorUpDown == 1) ||
      (doorLeftRight == 2 && doorUpDown == 2)
    ) {
      [ptLongStart, ptLongEnd] = [ptLongEnd, ptLongStart];
      // vecShort = new THREE.Vector3(-vecShort.x, -vecShort.y, 0);
    }
    if (
      (doorLeftRight == 1 && doorUpDown == 2) ||
      (doorLeftRight == 2 && doorUpDown == 2)
    ) {
      vecShort = new THREE.Vector3(-vecShort.x, -vecShort.y, 0);
    }
    // 计算门的长度作为弧的半径
    let radius = ptLongStart.distanceTo(ptLongEnd);

    // 创建门扇多段线
    let doorLeaf = new McDbPolyline();

    // 添加起点
    doorLeaf.addVertexAt(ptLongStart);

    // 计算弧线的点，使用vecShort的方向，并反转方向
    let segments = 16; // 弧线分段数
    for (let i = 0; i <= segments; i++) {
      let angle = (Math.PI / 2) * (i / segments);
      if (
        (doorLeftRight == 2 && doorUpDown == 1) ||
        (doorLeftRight == 1 && doorUpDown == 2)
      ) {
        angle = -angle;
      }
      let x =
        ptLongStart.x +
        radius * vecShort.x * Math.cos(angle) -
        radius * vecShort.y * Math.sin(angle);
      let y =
        ptLongStart.y +
        radius * vecShort.y * Math.cos(angle) +
        radius * vecShort.x * Math.sin(angle);
      doorLeaf.addVertexAt(new McGePoint3d(x, y, 0));
    }

    doorLeaf.setxDataString("Guid", this.Guid);
    doorLeaf.setxDataString("classTypeName", this.classTypeName);
    doorLeaf.trueColor = new McCmColor(
      this.Color.r,
      this.Color.g,
      this.Color.b
    );
    doorLeaf.visible = visible;

    let doorLeafMcDb = rlAppObj.mxcadObject.drawEntity(doorLeaf);
    this.otherDrawIds.push(doorLeafMcDb);
  }

  //绘制双开门样式
  drawDoubleDoorStyle() {
    if (!this.draw2dData) return;
    let visible = store.state.displayData.doorsDisplay;
    if (!this.OtherData) return;
    let OtherData = null;
    if (typeof this.OtherData === "string") {
      OtherData = JSON.parse(this.OtherData);
      if (typeof OtherData === "string") {
        OtherData = JSON.parse(OtherData);
      }
    } else {
      OtherData = this.OtherData;
    }
    let doorUpDown = OtherData.doorUpDown;
    // 获取门的基本点位和向量
    let ptLongStart = this.draw2dData.ptLongStart;
    let ptLongEnd = this.draw2dData.ptLongEnd;
    // 计算门的长度作为弧的半径
    let radius = ptLongStart.distanceTo(ptLongEnd);
    let ptLongStart1 = ptLongStart;
    let vecShort = this.draw2dData.vecShort;
    if (doorUpDown == 2) {
      let shortStart = this.draw2dData.ptShortStart;
      let shortEnd = this.draw2dData.ptShortEnd;
      let dist = shortStart.distanceTo(shortEnd);
      ptLongStart1 = MovePt(ptLongStart1, vecShort, dist);
      vecShort = new THREE.Vector3(-vecShort.x, -vecShort.y, 0);
    }
    let radiusT = radius / 2;
    // 创建门扇多段线
    let doorLeaf = new McDbPolyline();

    // 添加起点
    doorLeaf.addVertexAt(ptLongStart1);

    // 计算弧线的点，使用vecShort的方向，并反转方向
    let segments = 16; // 弧线分段数
    for (let i = 0; i <= segments; i++) {
      let angle = (Math.PI / 2) * (i / segments);
      if (doorUpDown == 2) angle = -angle;
      let x =
        ptLongStart1.x +
        radiusT * vecShort.x * Math.cos(angle) -
        radiusT * vecShort.y * Math.sin(angle);
      let y =
        ptLongStart1.y +
        radiusT * vecShort.y * Math.cos(angle) +
        radiusT * vecShort.x * Math.sin(angle);
      doorLeaf.addVertexAt(new McGePoint3d(x, y, 0));
    }

    doorLeaf.setxDataString("Guid", this.Guid);
    doorLeaf.setxDataString("classTypeName", this.classTypeName);
    doorLeaf.trueColor = new McCmColor(
      this.Color.r,
      this.Color.g,
      this.Color.b
    );
    doorLeaf.visible = visible;

    let doorLeafMcDb = rlAppObj.mxcadObject.drawEntity(doorLeaf);
    this.otherDrawIds.push(doorLeafMcDb);

    let ptLongStart2 = ptLongEnd;
    if (doorUpDown == 2) {
      let shortStart = this.draw2dData.ptShortStart;
      let shortEnd = this.draw2dData.ptShortEnd;
      let dist = shortStart.distanceTo(shortEnd);
      ptLongStart2 = MovePt(ptLongStart2, this.draw2dData.vecShort, dist);
    }
    // 创建门扇多段线
    let doorLeaf1 = new McDbPolyline();

    // 添加起点
    doorLeaf1.addVertexAt(ptLongStart2);

    // 计算弧线的点，使用vecShort的方向，并反转方向
    for (let i = 0; i <= segments; i++) {
      let angle = (Math.PI / 2) * (i / segments);
      if (doorUpDown == 1) angle = -angle;
      let x =
        ptLongStart2.x +
        radiusT * vecShort.x * Math.cos(angle) -
        radiusT * vecShort.y * Math.sin(angle);
      let y =
        ptLongStart2.y +
        radiusT * vecShort.y * Math.cos(angle) +
        radiusT * vecShort.x * Math.sin(angle);
      doorLeaf1.addVertexAt(new McGePoint3d(x, y, 0));
    }

    doorLeaf1.setxDataString("Guid", this.Guid);
    doorLeaf1.setxDataString("classTypeName", this.classTypeName);
    doorLeaf1.trueColor = new McCmColor(
      this.Color.r,
      this.Color.g,
      this.Color.b
    );
    doorLeaf1.visible = visible;

    let doorLeafMcDb1 = rlAppObj.mxcadObject.drawEntity(doorLeaf1);
    this.otherDrawIds.push(doorLeafMcDb1);
  }

  //绘制平开门样式
  drawFlatDoorStyle() {
    if (!this.draw2dData) return;
    // if (!this.OtherData) return;
    // let OtherData = null;
    // if (typeof this.OtherData === "string") {
    //   OtherData = JSON.parse(this.OtherData);
    //   if (typeof OtherData === "string") {
    //     OtherData = JSON.parse(OtherData);
    //   }
    // } else {
    //   OtherData = this.OtherData;
    // }
    // let doorUpDown = OtherData.doorUpDown;
    let visible = store.state.displayData.doorsDisplay;
    let ptLongStart = this.draw2dData.ptLongStart;
    let ptLongEnd = this.draw2dData.ptLongEnd;
    let vecShort = this.draw2dData.vecShort;
    // if (doorUpDown == 2) {
    //   let shortStart = this.draw2dData.ptShortStart;
    //   let shortEnd = this.draw2dData.ptShortEnd;
    //   let dist = shortStart.distanceTo(shortEnd);
    //   ptLongStart = MovePt(ptLongStart, vecShort, dist);
    //   ptLongEnd = MovePt(ptLongEnd, vecShort, dist);
    //   vecShort = new THREE.Vector3(-vecShort.x, -vecShort.y, 0);
    // }
    let vecShort1 = new THREE.Vector3(-vecShort.x, -vecShort.y, 0);
    let ptLongStart1 = MovePt(ptLongStart, vecShort, this.m_wallThick / 2);
    let ptLongEnd1 = MovePt(ptLongEnd, vecShort, this.m_wallThick / 2);
    //绘制最大的矩形
    let polyline = new McDbPolyline();
    polyline.addVertexAt(ptLongStart);
    polyline.addVertexAt(ptLongStart1);
    polyline.addVertexAt(ptLongEnd1);
    polyline.addVertexAt(ptLongEnd);
    polyline.addVertexAt(ptLongStart);
    polyline.setxDataString("Guid", this.Guid);
    polyline.setxDataString("classTypeName", this.classTypeName);
    polyline.trueColor = new McCmColor(
      this.Color.r,
      this.Color.g,
      this.Color.b
    );
    polyline.drawOrder = 99999999;
    polyline.visible = visible;
    let polylineMcDb = rlAppObj.mxcadObject.drawEntity(polyline);
    this.otherDrawIds.push(polylineMcDb);
    //绘制中间左侧矩形
    let ptCenter = new THREE.Vector3(
      (ptLongStart1.x + ptLongEnd1.x) / 2,
      (ptLongStart1.y + ptLongEnd1.y) / 2,
      0
    );
    let dist = (ptLongStart1.distanceTo(ptLongEnd1) / 2 / 10) * 6;
    let ptCenter1 = MovePt(ptCenter, vecShort1, 20);
    let vecLong = new THREE.Vector3()
      .subVectors(ptLongStart1, ptLongEnd1)
      .normalize();
    let pt1 = MovePt(ptCenter1, vecLong, dist);
    let pt2 = MovePt(pt1, vecShort, 20);
    let polyline1 = new McDbPolyline();
    polyline1.addVertexAt(ptCenter);
    polyline1.addVertexAt(ptCenter1);
    polyline1.addVertexAt(pt1);
    polyline1.addVertexAt(pt2);
    polyline1.setxDataString("Guid", this.Guid);
    polyline1.setxDataString("classTypeName", this.classTypeName);
    polyline1.trueColor = new McCmColor(
      this.Color.r,
      this.Color.g,
      this.Color.b
    );
    polyline1.drawOrder = 99999999;
    polyline1.visible = visible;
    let polylineMcDb1 = rlAppObj.mxcadObject.drawEntity(polyline1);
    this.otherDrawIds.push(polylineMcDb1);

    //绘制中间右侧矩形
    let pt3 = MovePt(ptCenter1, vecLong, -dist);
    let pt4 = MovePt(pt3, vecShort, 20);
    let polyline2 = new McDbPolyline();
    polyline2.addVertexAt(ptCenter);
    polyline2.addVertexAt(ptCenter1);
    polyline2.addVertexAt(pt3);
    polyline2.addVertexAt(pt4);
    polyline2.setxDataString("Guid", this.Guid);
    polyline2.setxDataString("classTypeName", this.classTypeName);
    polyline2.trueColor = new McCmColor(
      this.Color.r,
      this.Color.g,
      this.Color.b
    );
    polyline2.drawOrder = 99999999;
    polyline2.visible = visible;
    let polylineMcDb2 = rlAppObj.mxcadObject.drawEntity(polyline2);
    this.otherDrawIds.push(polylineMcDb2);

    //绘制门左侧矩形
    let pt5 = MovePt(ptLongStart1, vecShort, 20);
    let pt6 = MovePt(pt5, vecLong, -dist);
    let pt7 = MovePt(pt6, vecShort1, 20);
    let polyline3 = new McDbPolyline();
    polyline3.addVertexAt(ptLongStart1);
    polyline3.addVertexAt(pt5);
    polyline3.addVertexAt(pt6);
    polyline3.addVertexAt(pt7);
    polyline3.setxDataString("Guid", this.Guid);
    polyline3.setxDataString("classTypeName", this.classTypeName);
    polyline3.trueColor = new McCmColor(
      this.Color.r,
      this.Color.g,
      this.Color.b
    );
    polyline3.drawOrder = 99999999;
    polyline3.visible = visible;
    let polylineMcDb3 = rlAppObj.mxcadObject.drawEntity(polyline3);
    this.otherDrawIds.push(polylineMcDb3);

    //绘制门右侧矩形
    let pt8 = MovePt(ptLongEnd1, vecShort, 20);
    let pt9 = MovePt(pt8, vecLong, dist);
    let pt10 = MovePt(pt9, vecShort1, 20);
    let polyline4 = new McDbPolyline();
    polyline4.addVertexAt(ptLongEnd1);
    polyline4.addVertexAt(pt8);
    polyline4.addVertexAt(pt9);
    polyline4.addVertexAt(pt10);
    polyline4.setxDataString("Guid", this.Guid);
    polyline4.setxDataString("classTypeName", this.classTypeName);
    polyline4.trueColor = new McCmColor(
      this.Color.r,
      this.Color.g,
      this.Color.b
    );
    polyline4.drawOrder = 99999999;
    polyline4.visible = visible;
    let polylineMcDb4 = rlAppObj.mxcadObject.drawEntity(polyline4);
    this.otherDrawIds.push(polylineMcDb4);

    let dist2 = (ptLongStart1.distanceTo(ptLongEnd1) / 2 / 10) * 4;
    let dist3 = (dist2 / 10) * 8;
    let dist4 = dist2 / 10;
    let dist5 = (dist3 / 10) * 6;
    //绘制门左的箭头
    let pt11 = MovePt(pt6, vecLong, -dist4);
    let pt12 = MovePt(pt11, vecLong, -dist3);
    let pt13 = MovePt(pt11, vecLong, -dist5);
    let pt14 = MovePt(pt13, vecShort, 5);
    let polyline5 = new McDbPolyline();
    polyline5.addVertexAt(pt11);
    polyline5.addVertexAt(pt12);
    polyline5.addVertexAt(pt14);
    polyline5.addVertexAt(pt13);
    polyline5.setxDataString("Guid", this.Guid);
    polyline5.setxDataString("classTypeName", this.classTypeName);
    polyline5.trueColor = new McCmColor(
      this.Color.r,
      this.Color.g,
      this.Color.b
    );
    polyline5.drawOrder = 99999999;
    polyline5.visible = visible;
    let polylineMcDb5 = rlAppObj.mxcadObject.drawEntity(polyline5);
    this.otherDrawIds.push(polylineMcDb5);

    //绘制门右的箭头
    let pt15 = MovePt(pt9, vecLong, dist4);
    let pt16 = MovePt(pt15, vecLong, dist3);
    let pt17 = MovePt(pt15, vecLong, dist5);
    let pt18 = MovePt(pt17, vecShort, 5);
    let polyline6 = new McDbPolyline();
    polyline6.addVertexAt(pt15);
    polyline6.addVertexAt(pt16);
    polyline6.addVertexAt(pt18);
    polyline6.addVertexAt(pt17);
    polyline6.setxDataString("Guid", this.Guid);
    polyline6.setxDataString("classTypeName", this.classTypeName);
    polyline6.trueColor = new McCmColor(
      this.Color.r,
      this.Color.g,
      this.Color.b
    );
    polyline6.drawOrder = 99999999;
    polyline6.visible = visible;
    let polylineMcDb6 = rlAppObj.mxcadObject.drawEntity(polyline6);
    this.otherDrawIds.push(polylineMcDb6);
  }

  getDraw2dData() {
    if (!this.index2dData) return;

    this.eraseOtherDraw();
    let ptArray = [];
    for (let i = 0; i < this.index2dData.length; i += 3) {
      ptArray.push(
        new McGePoint3d(this.index2dData[i], this.index2dData[i + 1], 0)
      );
    }
    if (ptArray.length != 4) return;

    let pt0 = ptArray[0];
    let pt1 = ptArray[1];
    let pt2 = ptArray[2];
    let pt3 = ptArray[3];
    let dist1 = pt0.distanceTo(pt1);
    let dist2 = pt0.distanceTo(pt3);

    //获取短板和长边的点位,以及方向向量
    if (dist1 === this.m_sectParamData.B) {
      this.draw2dData.ptLongStart = pt0;
      this.draw2dData.ptLongEnd = pt1;
      this.draw2dData.vecLong = new THREE.Vector3()
        .subVectors(pt0, pt1)
        .normalize();
      this.draw2dData.ptShortStart = pt1;
      this.draw2dData.ptShortEnd = pt2;
      this.draw2dData.vecShort = new THREE.Vector3()
        .subVectors(pt2, pt1)
        .normalize();
    } else {
      this.draw2dData.ptShortStart = pt3;
      this.draw2dData.ptShortEnd = pt0;
      this.draw2dData.vecShort = new THREE.Vector3()
        .subVectors(pt0, pt3)
        .normalize();
      this.draw2dData.ptLongStart = pt2;
      this.draw2dData.ptLongEnd = pt3;
      this.draw2dData.vecLong = new THREE.Vector3()
        .subVectors(pt2, pt3)
        .normalize();
    }
    this.draw2dData.ptLongCenterStart = MovePt(
      this.draw2dData.ptLongStart,
      this.draw2dData.vecShort,
      this.m_wallThick / 2
    );
    this.draw2dData.ptLongCenterEnd = MovePt(
      this.draw2dData.ptLongEnd,
      this.draw2dData.vecShort,
      this.m_wallThick / 2
    );
  }

  // 数据转换
  convert() {
    if (!this.isWasmGeted || (!this.index2dData && !this.index3dData)) {
      let holeEcc = this.Ecc; //1==居左，0==居中，-1==居右
      let gridLength = new THREE.Vector3(
        this.endPoint.x,
        this.endPoint.y,
        0
      ).distanceTo(new THREE.Vector3(this.startPoint.x, this.startPoint.y, 0));
      if (this.Ecc == 0) {
        holeEcc = gridLength / 2 - Number(this.m_sectParamData.B) / 2;
      } else if (this.Ecc == 1) {
        holeEcc = 0;
      } else if (this.Ecc == -1) {
        holeEcc = gridLength - Number(this.m_sectParamData.B);
      }

      let res = getPKPM_WallHoleData(
        this.startPoint.x,
        this.startPoint.y,
        this.endPoint.x,
        this.endPoint.y,
        Number(this.m_sectParamData.B),
        Number(this.m_sectParamData.H),
        Number(this.m_wallThick),
        Number(this.m_wallEcc),
        Number(holeEcc),
        Number(this.HDiff),
        Number(this.LevelB)
      );
      if (!res) return;
      res = JSON.parse(res);
      res.startPoint = {
        x: this.startPoint.x,
        y: this.startPoint.y,
        z: 0,
      };
      res.endPoint = {
        x: this.endPoint.x,
        y: this.endPoint.y,
        z: 0,
      };
      let OtherData = null;
      if (typeof this.OtherData === "string") {
        OtherData = JSON.parse(this.OtherData);
      } else {
        OtherData = this.OtherData;
      }
      res.doorLeftRight = OtherData.doorLeftRight;
      res.doorUpDown = OtherData.doorUpDown;
      res.doorOpenType = OtherData.doorOpenType;
      this.getModelDrawData(res);
      // let wasmData = JSON.parse(res);
      // let data = `{"${this.Guid}":${JSON.stringify(wasmData)}}`;
      // let data3D = this.getModel3dData(data);
      // if (!data3D) return;

      // data3D = JSON.parse(data3D)["3D"][this.Guid];
      // this.points = data3D.Points;
      // this.index3dData = {
      //   points: data3D.Points,
      //   faces: data3D["3dFaces"].map((item) => item.index).flat(),
      // };
    } else {
      if (!Array.isArray(this.index2dData)) {
        this.index2dData = this.index2dData.split(",").map(Number);
      }
    }
    this.getDraw2dData();
    if (this.doorsWindowsType === 1) {
      this.drawDoorStyle();
    } else if (this.doorsWindowsType === 0) {
      this.drawWindowStyle();
    }
    // this.m_sectGroupName = this.m_sectParamData.B.toString();
  }

  // wasm截面数据转换
  // getModelDrawData(modelData) {
  //   // this.index3dData = modelData["3D"]["3dFaces"]
  //   //   .map((item) => item.index)
  //   //   .flat();
  //   this.index2dData = modelData["2DUpView"];
  //   this.SectData = modelData["SectData"];
  //   this.OtherData = JSON.stringify(modelData);
  // }

  draw() {
    if ((!this.index2dData && !this.index3dData) || !this.isWasmGeted) {
      this.isWasmGeted = false;
      this.convert();
    }
    this.m_sectGroupName =
      this.m_sectParamData.B + "*" + this.m_sectParamData.H;
    this.CurrtSect = this.m_sectGroupName + "*" + this.m_wallThick; //增加墙厚尺寸
    super.draw();
    if (this.mcDbPolyline) {
      this.mcDbPolyline.setxDataString(
        "doorsWindowsType",
        this.doorsWindowsType
      );
      if (this.doorsWindowsType === 1) this.mcDbPolyline.visible = false;
    }
    this.m_gridData ? (this.m_gridData.m_wallHoleId = this.Guid) : "";
  }

  // 克隆
  async myClone() {
    let newObj = new rlWallHoleData();
    super.cloneData(newObj);

    newObj.m_gridData = this.m_gridData;
    newObj.Ecc = this.Ecc;
    newObj.HDiff = this.HDiff;
    newObj.HDiff1 = this.HDiff1;
    newObj.HDiff2 = this.HDiff2;
    newObj.HDiffB = this.HDiffB;
    newObj.Color = this.Color;
    newObj.points = this.points;
    newObj.startPoint = this.startPoint;
    newObj.endPoint = this.endPoint;
    newObj.OtherData = this.OtherData;
    //与网格数据绑定
    newObj.m_gridData.m_wallHoleId = newObj.Guid;
    return newObj;
  }

  getDataBase() {
    let data = super.getDataBase();
    data["SectGuid"] = this.m_sectParamData.Guid;

    if (this.m_gridData) data["GridGuid"] = this.m_gridData.Guid;
    data["Drawing_2D"] = this.index2dData.join(",");
    data["Drawing_3D"] = JSON.stringify(this.index3dData);
    //data["OtherData"] = this.OtherData;
    data["Ecc"] = this.Ecc;
    data["HDiff"] = this.HDiff;
    data["Mat"] = this.Mat;
    data["DoorsWindowsType"] = this.doorsWindowsType;
    data["IsPartitionWall"] = this.IsPartitionWall;
    return data;
  }

  //获取图形绘制数据--用于撤销回退
  getDrawData() {
    let data = super.getDrawData();

    data["m_gridData"] = this.m_gridData.Guid;
    data["Ecc"] = this.Ecc;
    data["HDiff"] = this.HDiff;
    data["m_wallThick"] = this.m_wallThick; //墙洞所在墙的墙厚
    data["m_wallEcc"] = this.m_wallEcc; //墙洞所在墙的偏轴

    data["doorsWindowsType"] = this.doorsWindowsType;
    data["Mat"] = this.Mat;
    data["IsPartitionWall"] = this.IsPartitionWall;
    data["OtherData"] = this.OtherData;
    data["m_wallHoleId"] = this.m_wallHoleId;
    data["startPoint"] = [this.startPoint.x, this.startPoint.y];
    data["endPoint"] = [this.endPoint.x, this.endPoint.y];

    return data;
  }

  //用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    let tempOtherData = !this.OtherData
      ? {}
      : typeof this.OtherData === "string"
      ? JSON.parse(this.OtherData)
      : this.OtherData;

    if (obj.m_gridData) {
      if (obj.IsPartitionWall) {
        this.m_gridData = getEntityData({
          Guid: obj.m_gridData,
          classTypeName: "rlPartitionWallSeg",
        });
      } else {
        this.m_gridData = getEntityData({
          Guid: obj.m_gridData,
          classTypeName: "rlGrid",
        });
      }
    }

    this.startPoint = new McGePoint3d(obj.startPoint[0], obj.startPoint[1], 0);
    this.endPoint = new McGePoint3d(obj.endPoint[0], obj.endPoint[1], 0);
    this.IsPartitionWall = obj.IsPartitionWall;
    this.m_wallThick = obj.m_wallThick; //墙洞所在墙的墙厚
    this.m_wallEcc = obj.m_wallEcc; //墙洞所在墙的偏轴
    // const wallSect = obj.wallSect;
    this.Ecc = obj.Ecc; //洞口定位距离
    this.HDiff = obj.HDiff; //洞口底部标高
    this.Color = obj.Color;
    //与网格数据绑定
    this.m_gridData.m_wallHoleId = this.Guid;
    this.index2dData = obj.index2dData;
    this.index3dData = obj.index3dData;
    this.points = obj.points;
    this.doorsWindowsType = obj.doorsWindowsType;

    this.Mat = obj.Mat;
    //与网格数据绑定
    if (
      this.m_gridData.classTypeName == "rlPartitionWallSeg" &&
      !this.m_gridData.m_HoleIdArray.includes(this.Guid)
    ) {
      this.m_gridData.m_HoleIdArray.push(this.Guid);
    }

    this.Color = obj.Color ? obj.Color : "#fff";
    this.setMatName();
  }

  eraseOtherDraw() {
    this.otherDrawIds.forEach((item) => {
      if (item) {
        item.erase();
      }
    });
  }
  // 删除
  erase() {
    if (this.m_gridData.classTypeName == "rlPartitionWallSeg") {
      if (this.m_gridData) {
        this.m_gridData.m_HoleIdArray = this.m_gridData.m_HoleIdArray.filter(
          (item) => item !== this.Guid
        );
        this.m_gridData.drawBreakWall();

        if (this.m_gridData.m_HoleIdArray.length === 0) {
          this.m_gridData.mcDbId.getMcDbEntity().visible = true;
        }
      }
    } else if (this.m_gridData) {
      this.m_gridData.m_wallHoleId = null;
      if (this.m_gridData.m_wallId) {
        const rlWAll = getEntityData({
          Guid: this.m_gridData.m_wallId,
          classTypeName: "rlWallSeg",
        });
        if (rlWAll) {
          if (rlWAll.m_HoleId == this.Guid) {
            rlWAll.m_HoleId = null;
          }
          rlWAll.drawBreakWall();
        }
      }
    }
    this.eraseOtherDraw();
    super.erase();
  }
}

export { rlWallHoleData };
